/*
 * Funcões compare para serem usadas em metodos 'sort'
 * Por enquanto apenas ordenando por ID e nome, e sempre ascedente
 */

export function compareById(a, b) {
	if (a.id < b.id) {
		return -1;
	}
	if (a.id > b.id) {
		return 1;
	}
	return 0;
}

export function compareByNome(a, b) {
	if (a.nome < b.nome) {
		return -1;
	}
	if (a.nome > b.nome) {
		return 1;
	}
	return 0;
}
